import { PageTitle } from '@/components/ui';
import { useRequireB2CPermission } from '@/hooks';
import { useCreateAvailableDate } from '@/services/mutations/available-date';
import { useNavigate } from 'react-router-dom';
import { CalendarDataProps, CreateCalendarContainer } from './components';

const CreateProfessionalAgenda = () => {
	const navigate = useNavigate();
	const { isLoading, canManageAvailability } = useRequireB2CPermission();
	const { mutate, isSuccess } = useCreateAvailableDate(() =>
		navigate('/profissional/horarios'),
	);

	const handleSubmit = ({ selectedDayWeeks, slots }: CalendarDataProps) => {
		// Validação
		if (selectedDayWeeks.length === 0 || slots.length === 0) return;

		// LÓGICA NESTED LOOP: Para cada dia, crie todos os slots definidos
		selectedDayWeeks.forEach((day) => {
			slots.forEach((slot) => {
				if (slot.start && slot.end) {
					mutate({
						week_day: day,
						start_time: slot.start.value,
						end_time: slot.end.value,
					});
				}
			});
		});
	};

	if (isLoading || !canManageAvailability) {
		return null;
	}

	return (
		<section className="space-y-6 px-4 py-6">
			<PageTitle text="Meus horários" />

			<div className="w-full max-w-4xl space-y-6">
				<div>
					<h2 className="text-lg font-medium text-dark">
						Criar sessão disponível
					</h2>
					<p className="text-zinc-600">
						Defina sua disponibilidade para a semana selecionando os
						dias e o horário.
					</p>
					<div className="mt-1 flex gap-1">
						<button
							className="border-b border-blue-500 text-sm font-medium leading-3 text-blue-500"
							onClick={() =>
								navigate(
									'/profissional/horarios/disponibilidade/guia',
								)
							}
						>
							Guia
						</button>
						<p className="text-sm text-zinc-500">
							para gerar horários de disponibilidade.
						</p>
					</div>
				</div>

				<CreateCalendarContainer
					onAction={handleSubmit}
					isSuccess={isSuccess}
					onCancel={() => navigate('/profissional/horarios')}
				/>
			</div>
		</section>
	);
};

export { CreateProfessionalAgenda };
